exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 767.98px) {\n  .sizes_btn__95DqM button {\n    font-size: 0.5rem; }\n  .sizes_item__4AKUR {\n    font-size: 0.5rem !important; } }\n", ""]);

// Exports
exports.locals = {
	"btn": "sizes_btn__95DqM",
	"item": "sizes_item__4AKUR"
};